export const LEGAL_INFO = {
    businessName: '위클리랩',
    representative: '최동철',
    businessNumber: '557-36-01673',
    contactEmail: 'ddagae0805@gmail.com',
    serviceName: '출석부 프로그램',
    effectiveDate: '2026-05-06',
} as const;

export const LEGAL_ROUTES = {
    terms: '/terms',
    privacy: '/privacy',
    refund: '/refund',
} as const;

export const SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/weekly-school/',
} as const;
